import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';

const store = new Vapi({
  axios,
  state: {
  },
})
  .get({
    action: 'getUserNotifyPreferences',
    path: '/user/notify/preferences',
  })
  .put({
    action: 'setUserNotifyPreferences',
    path: '/user/notify/preferences',
  })
  .getStore();

export default store;
